import 'wpsl-js';
import 'underscore';

function initGoogleMapEmbed() {
	const nearMeButton = document.querySelector(
		".google-map-embed__search-near-me",
	);

	if (nearMeButton) {
		nearMeButton.addEventListener("click", () => {
			const latLng = wpslSettings.startLatlng.split(",");
			const startLatLng = new google.maps.LatLng(latLng[0], latLng[1]);
			window.wpslCheckGeolocation(startLatLng, wpslInfoWindow);
		});
	}
}

if (typeof window.wpslAddons !== "object") {
	window.wpslAddons = {};
}

window.wpslAddons.arcadianGoogleMapEmbed = {
	init: initGoogleMapEmbed,
};

const toggleMapList = () => {
	const toggle = document.querySelector(".google-map-embed__list-map-toggle");
	const toggleElement = () => {
		if (toggle) {
			const fieldset = toggle.querySelector(".list-map-toggle__fieldset");
			const showMap = fieldset.querySelector("#show-map");
			const map = document.querySelector(".google-map-embed__wrapper");
			const list = document.querySelector(".location-card-row__wrapper");

			if (showMap.checked) {
				list.classList.add("hidden");
				map.classList.remove("hidden");
			} else {
				map.classList.add("hidden");
				list.classList.remove("hidden");
			}
		}
	};

	toggleElement();

	toggle.addEventListener("click", toggleElement);
};

if (document.readyState !== "loading") {
	toggleMapList();
} else {
	document.addEventListener("DOMContentLoaded", toggleMapList);
}
